import { Button } from "antd";
import { useExport } from "./hooks/useExport";

export const ContractFess = () => {
  const { isLoading, onExport } = useExport();

  return (
    <Button
      className="pa-0"
      type="link"
      size="small"
      disabled={isLoading}
      onClick={onExport}
    >
      Account Fee Configuration
    </Button>
  );
};
